import { styled } from '@mui/material';
import {
  default as MuiTooltip,
  tooltipClasses,
  TooltipProps,
} from '@mui/material/Tooltip';

const Tooltip = styled(({ className, ...props }: TooltipProps) => (
  <MuiTooltip arrow {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.customShadows.lg,
    color: theme.palette.text.primary,
    fontSize: theme.typography.body3.fontSize,
    fontWeight: theme.typography.body3.fontWeight,
    lineHeight: theme.typography.body3.lineHeight,
    padding: theme.spacing(1, 1.5),
  },

  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.background.paper,
  },
}));

export default Tooltip;
